import React, { Component } from "react";
import ReactDOM from "react-dom";

import { withRouter } from "react-router-dom";

import Api from "../../../../lib/componentApi";
import getAppErrors from "../../../../lib/appErrors";
import validateForm from "../../../../lib/validateForm";

import Edit from "../../../../components/Users/Profile/Edit";
import AppErrors from "../../../../components/Common/AppErrors";
import getAppStrings from "../../../../lib/appStrings";

class ProfileEdit extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    const { firstName, lastName, mobileNumber, email } = user;
    this.state = {
      firstName,
      lastName,
      mobileNumber,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      loading: false,
      errorMessage: "",
      email,
      formErrors: {
        firstName: "",
        lastName: "",
        mobileNumber: "",
        email: "",
        confirmPassword: "",
        currentPassword: "",
        newPassword: ""
      },
      errorTitle: null,
      active: true,
      showErrors: false
    };
  }
  handleChange = event => {
    event.preventDefault();
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value.trim(),
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "signup");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { email, firstName, lastName, mobileNumber } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (
            email &&
            firstName &&
            lastName &&
            mobileNumber &&
            !errors.length
          ) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  handleChangePassword = event => {
    const input = event.target.id;
    this.setState(
      {
        [input]: event.target.value.trim(),
        showErrors: false
      },
      () => {
        const currentState = { [input]: this.state[input] };
        const inputError = validateForm(currentState, "signup");
        const { formErrors } = this.state;
        formErrors[input] = inputError;
        this.setState({ formErrors }, () => {
          const { currentPassword, newPassword, confirmPassword } = this.state;
          const errors = Object.values(this.state.formErrors).filter(Boolean);
          if (currentPassword && newPassword && !errors.length) {
            if (newPassword === confirmPassword) {
              this.setState({ active: true });
            } else {
              formErrors.confirmPassword =
                "Password and confirm password does not match";
              this.setState({
                formErrors
              });
            }
          } else {
            this.setState({ active: false });
          }
        });
      }
    );
  };
  isValid = () => {
    const { email, firstName, lastName, mobileNumber } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (email && firstName && lastName && mobileNumber && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  isValidPass = () => {
    const {
      currentPassword,
      newPassword,
      confirmPassword,
      formErrors
    } = this.state;
    const errors = Object.values(formErrors).filter(Boolean);
    if (currentPassword && newPassword && confirmPassword && !errors.length) {
      return true;
    } else {
      this.setState(
        {
          showErrors: true
        },
        () => {
          return false;
        }
      );
    }
  };
  handleSubmitPassword = event => {
    event.preventDefault();
    const isValid = this.isValidPass();
    if (isValid) {
      const { currentPassword, newPassword } = this.state;
      const { getProfile } = this.props;
      const passwordData = {
        oldPassword: currentPassword,
        newPassword
      };
      this.setState({ loading: true });
      Api.post("/api/profile/password", passwordData, (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          const errorMessage = getAppErrors(response.code);
          var body = document.body;
          body.classList.add("body-overflow");
          this.setState({
            errorMessage:
              (errorMessage && errorMessage.message) || response.message,
            active: false
          });
        } else {
          getProfile({ shouldUpdate: true });
        }
        this.setState({ loading: false });
      });
    }
  };
  closeVerification = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    const { getProfile } = this.props;
    this.setState({ smsVerification: false }, () => {
      getProfile({ shouldUpdate: true });
    });
  };
  //iki fonksiyon aynı işlemi gerçekleştiriyor, düzenle
  onSmsVerified = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    const { getProfile } = this.props;
    this.setState({ smsVerification: false }, () => {
      getProfile({ shouldUpdate: true });
    });
  };
  sendSmsVerificationKey = () => {
    Api.post("/api/send/sms/key", {}, (response, errors) => {
      var body = document.body;
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        let message =
          (errorMessage && errorMessage.message) || response.message;
        if (response.code === 2043) {
          const param = response.params[0] || 10;
          message = message.replace("[:par1]", param);
        }
        body.classList.add("body-overflow");
        this.setState({
          errorMessage: message,
          active: false,
          smsVerificationSection: false
        });
      } else {
        if (response.status) {
          this.setState({
            smsVerification: true
          });
        }
      }
    });
  };
  sendEmailVerificationKey = () => {
    Api.post("/api/send/email/key", {}, (response, errors) => {
      var body = document.body;
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        const errorMessage = getAppErrors(response.code);
        body.classList.add("body-overflow");
        this.setState({
          errorMessage:
            (errorMessage && errorMessage.message) || response.message,
          active: false
        });
      } else {
        body.classList.add("body-overflow");
        if (response.status) {
          const appString = getAppStrings(2091);
          this.setState({
            errorMessage: (appString && appString.message) || "Email sent.",
            errorTitle: (appString && appString.title) || "Yay!"
          });
        }
      }
    });
  };
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.isValid();
    if (isValid) {
      const { firstName, lastName, mobileNumber, email } = this.state;
      const { getProfile } = this.props;
      this.setState({ loading: true });
      Api.post(
        "/api/profile/info",
        { firstName, lastName, mobileNumber, email },
        (response, errors) => {
          var body = document.body;
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            const errorMessage = getAppErrors(response.code);
            body.classList.add("body-overflow");
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message,
              active: false
            });
          } else {
            getProfile({ shouldUpdate: true });
          }
          this.setState({ loading: false });
        }
      );
    }
  };
  onClickClose = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    const { user } = this.props;
    const { firstName, lastName, mobileNumber, email } = user;
    this.setState({
      errorMessage: "",
      errorTitle: "",
      firstName,
      lastName,
      mobileNumber,
      email
    });
  };
  submitPhoneNumber = (mobileNumber, error) => {
    const { email, firstName, lastName, formErrors } = this.state;
    const errors = Object.values(this.state.formErrors).filter(Boolean);
    if (error) {
      this.setState({
        formErrors: {
          ...formErrors,
          mobileNumber: error
        },
        showErrors: false,
        active: false
      });
    } else {
      this.setState(
        {
          mobileNumber,
          showErrors: false,
          formErrors: {
            ...formErrors,
            mobileNumber: ""
          }
        },
        () => {
          if (
            email &&
            firstName &&
            lastName &&
            mobileNumber &&
            !errors.length
          ) {
            this.setState({ active: true });
          } else {
            this.setState({ active: false });
          }
        }
      );
    }
  };
  render() {
    const {
      firstName,
      lastName,
      mobileNumber,
      email,
      active,
      errorMessage,
      errorTitle,
      formErrors,
      showErrors,
      loading,
      smsVerification
    } = this.state;
    const { onCloseSection, user } = this.props;
    const { smsVerified, emailVerified } = user;
    return (
      <React.Fragment>
        {(errorMessage &&
          ReactDOM.createPortal(
            <AppErrors
              message={errorMessage}
              title={errorTitle}
              onClickClose={() => this.onClickClose()}
            />,
            document.body
          )) || <noscript />}
        <Edit
          firstName={firstName}
          lastName={lastName}
          mobileNumber={mobileNumber}
          email={email}
          active={active}
          formErrors={formErrors}
          showErrors={showErrors}
          submitPhoneNumber={this.submitPhoneNumber}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          onCloseSection={onCloseSection}
          loading={loading}
          handleChangePassword={this.handleChangePassword}
          handleSubmitPassword={this.handleSubmitPassword}
          smsVerification={smsVerification}
          closeVerification={this.closeVerification}
          onSmsVerified={this.onSmsVerified}
          smsVerified={smsVerified}
          emailVerified={emailVerified}
          sendSmsVerificationKey={this.sendSmsVerificationKey}
          sendEmailVerificationKey={this.sendEmailVerificationKey}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(ProfileEdit);
